module.exports = __webpack_public_path__ + "media/images/home/not_bookmarked_icon-bab82be15586fc088a6926cc9e077f36.png";